/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { XeroSyncInfoDto } from './xero-sync.dto';

export const XeroSyncInfoMapper = entity<XeroSyncInfoDto>({
  xeroSyncLastCC: date(DateFormat.DateTime),
  xeroSyncLastJobs: date(DateFormat.DateTime),
  xeroSyncLastContacts: date(DateFormat.DateTime),
  xeroSyncLastInvoices: date(DateFormat.DateTime),
});
